import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { FormInput } from '../components/FormInput';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SystemLoading, checkLoading } from '../store/loadingStore';
import { useForm } from 'react-hook-form';
import { Button } from 'primereact/button';
import { Steps } from 'primereact/steps';
import { Tooltip } from 'primereact/tooltip';
import bgCtBottom from "../assets/images/layout/bg-ct-bottom.svg"
import LoginCommonOutline from './login/LoginCommonOutline';
import { F0010103Before, F0010101Before, F0010102Before, registerAcct, registerMainSubAcct, registerTaxIdNum } from '../utility/service/register-service';
import { checkDpSuccess, handleSessionClear, loginClientId } from '../utility/service/tool-service';
import { MessageContext, handleSuccessMessage } from '../store/messageStore';
import RegisterStep3 from './RegisterStep3';
import { AlertService, AlertType } from '../utility/service/alert-service';

import CompanyRoleSelector from "../components/layout/CompanyRoleSelector"
import { addFormValidator } from '../utility/validate/formValidator';
import { createAcctByInviteRecords, getInviteRecordsInfo } from '../utility/service/invite-service';
import cryptoJS from 'crypto-js';
import { gtwidp_authorization } from '../utility/service/dgr-service';
import RegInviteSubAcctStep3 from './RegInviteSubAcctStep3';
import { getSupportedLanguage } from '../utility/languageUtils';

const RegisterInvite = () => {

  const { t, i18n } = useTranslation();
  const [, loading] = useContext(SystemLoading);
  const [, dispatch] = useContext(MessageContext); //訊息視窗 
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [isExistCompany, setIsExistCompany] = useState(false);
  const { issuer } = useParams();
  const [confirmLoad,setConfirmLoad] = useState(false);
  const [formRule, setFormRule] = useState([]); //表單驗證
  const queryParams = new URLSearchParams(window.location.search);
  const [inviteObj,setInviteObj]= useState({});
  const formRef = useRef(null);
  const [interiorFlag,setTnteriorFlag] = useState('N');
  const [agreeMarketing, setAgreeMarketing] = useState(false);
  
  


  const {
    register,
    handleSubmit,
    resetField,
    reset,
    watch,
    getValues,
    setValue,
    clearErrors,
    control,
    formState: { errors,isValid }
  } = useForm({
    defaultValues: {
      userAcct: '',
      userPcode: ''
    },
    //錯誤驗證時機
    mode: 'all'
  });

  //表單驗證
  const registerOptions = {
    userAcct: { required: t('user_name_required') },
    userPcode: {
      required: t('password_required'),
      pattern: {
        value: /^[A-Z0-9]{6,12}$/i,
        message: t('validation.passwordPattern')
      }
    },
    userPcodeSecond: {
      required: t('password_required'),
      validate: (val) => {
        if (watch('userPcode') !== val) return t('validation.confirm_password')
      },
      pattern: {
        value: /^[A-Z0-9]{6,12}$/i,
        message: t('validation.passwordPattern')
      }
    },
    inviteCode: {
      required: t('validation.required'),
      maxLength: {
        value: 8,
        message: t('validation.limitMaxChar', { max: 8 })
    },
    //   pattern: {
    //     value: /^[0-9]*$/,
    //     message: t('validation.numberLen', { len: 8 })
    //   }
    }

  }

  useEffect(()=>{
    if(queryParams.get("inviteseq")!==null){
      handleSessionClear();
      sessionStorage.setItem("inviteseq",queryParams.get("inviteseq"));
      let themeType = queryParams.get("type")
      if(themeType){
        sessionStorage?.setItem("loadTheme",themeType==='A'?'green':'blue');
      }
    }
  },[queryParams])

  useEffect(()=>{
    if(issuer==='GOOGLE'){
      setActiveIndex(1);
    }
  },[issuer])

  // useEffect(()=>{
  //   if(issuer==='GOOGLE' && sessionStorage?.getItem("inviteseq")!==null && JSON.stringify(inviteObj)==='{}'){
  //     alert("useeffect inviteseq",1)
  //     setActiveIndex(1);
  //   }else if(issuer==='GOOGLE' && sessionStorage?.getItem("inviteseq")!==null && JSON.stringify(inviteObj)!=='{}'){
  //     alert("useeffect inviteObj",2)
  //     setActiveIndex(2);
  //   }
  // },[inviteObj])

  useEffect(() => {
    i18n.changeLanguage(getSupportedLanguage());
  }, [i18n])

  useEffect(()=>{
    axios_getCreateAcctBefore();
  },[])

  const generate_code_challenge = (code_verifier)=>{ 
    const code_verifier_sha = cryptoJS.SHA256(code_verifier);
    const code_verifier_b64 = cryptoJS.enc.Base64url.stringify(code_verifier_sha);
    return code_verifier_b64;
  }

  const handleLoginConfirm = (type,client_id) => {
    let redirectUrl = `${window.location.protocol}//${window.location.hostname}${window.location.port===''?'':`:${window.location.port}`}/website/esg/ui`
    // PKCE登入
    const code_verifier_ori = crypto.randomUUID();
    const code_verifier = code_verifier_ori+code_verifier_ori;
    // const code_verifier = 'B7gB0cY1C58ecNJ2J-231Ep-NmXgghAzgZg9nXu-vDo';
    const code_challenge = generate_code_challenge(code_verifier);
    // const code_challenge = 'Jhlf18b9aDFC5hkgQy3_MO1MznyS7kqMi32wELbhdos';
    sessionStorage.setItem("code_verifier",code_verifier);
    let state = crypto.randomUUID();
    let scope = "openid profile email"

    gtwidp_authorization(redirectUrl,state,scope,type,code_challenge,client_id);
  }

  const onRoleChange = (newColor, hasChanged)=>{
    if(hasChanged){
      setValue("userAcct","");
      setValue("userPcode","");
      setValue("userPcodeSecond","");
      clearErrors();
    }
  }

  const doubleCheckPcodeSecond = ()=>{
    let rule = setValidForm("userPcode");
    let newRules = {
      ...rule,
      validate: (val) => {
            if (watch('userPcode') !== val) return t('validation.confirm_password')
          }
    }
    return newRules;
  }

  // F0010101Before
  //建立前查詢form 規則 區分 主子帳戶
  const axios_getCreateAcctBefore = useCallback(()=>{
    let array = []
    F0010101Before()
      .then((res)=>{
        //第三步驟 
      if(checkDpSuccess(res)){
          res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result)
          })
      }
        return F0010103Before()
      }).then((res)=>{
        // 第二步驟 F0010102Before
        if(checkDpSuccess(res)){
          res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result)
          })
          setFormRule(array);
      }
      })
    
},[])

const axios_getF0010103Before=(identity)=>{
  F0010103Before(identity)
          .then((res)=>{
              if(checkDpSuccess(res)){
                let array = []
                  res?.data?.RespBody?.constraints?.forEach((item) => {
                      const result = addFormValidator(item?.field, res.data.RespBody.constraints);
                      array.push(result)
                  })
                  setFormRule((pre)=>{
                    return[...pre,...array]
                  });
              
              }
          })
}
  const setValidForm = useCallback((formId) => {
      if (formRule?.length > 0) {
          const tmp = formRule?.find((item) => {
              return Object.keys(item)[0] === formId
          });
          return tmp ? tmp[formId] : '';
      }
  }, [formRule]);


  const checkKeyDown = (e) => {
    // if (e.key === 'Enter') e.preventDefault();
    if (e.keyCode === 13) {
      console.log("checkKeyDown");
      e.stopPropagation();
    }
  };

  const inputCheckKeyDown = (e) => { //避免觸發 按enter 後 就觸發 onSubmit 事件冒泡 給input 使用 <FormInput enterClick事件 ; 一般input onKeyDown事件
    if (e.key === 'Enter') {
      console.log("preventDefault");
      e.preventDefault();
    }
  }

  const handleInviteCode = useCallback(() => {
    checkLoading(loading);
    let reqBody = {
        inviteSeq:sessionStorage?.getItem("inviteseq"),
        inviteCode:getValues("inviteCode")
    }    
    getInviteRecordsInfo(reqBody)
      .then((res) => {
        // alert(JSON.stringify(res))
        if (checkDpSuccess(res)) {
            let data = res?.data?.RespBody;
            setInviteObj(data);
            setValue("taxIdNum",data?.taxIdNum);
            setValue("companyName",data?.companyName);
            setValue("industryCode",data?.industryCode);
            setValue("companyEmail",data.email);
            setValue("userName",data?.userName);
            // setValue("userPhone",data?.phone);
            setValue("userEmail",data?.userEmail);
            setValue("companyAddress",data?.address);
            setValue("companyLeader",data?.leader);
            setActiveIndex(2);
            setTnteriorFlag(data?.interiorFlag);
            handleSuccessMessage(dispatch, t('inviteCode') + ' ' + t('message.success'));
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      })

  },[])


  const handleNextStep = useCallback((e) => {
    e.preventDefault();
    if (activeIndex === 1) {
      handleInviteCode();
    } else if (activeIndex === 2) {
      // Handle step 3
    }
  }, [activeIndex, handleInviteCode]);

  const handleMainSubAcct = (reqBody) => { //第3步
    createAcctByInviteRecords(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          setConfirmLoad(false);
          // 建立成功後移除session中的 inviteseq 
          sessionStorage.removeItem("inviteseq");
          AlertService.ask({
            title: `WOO HOO`,
            text: t('registerSuccess'),  //res?.data.RespBody?.message,
            type: AlertType.info,
            showCancelButton: false,
            confirmButtonText: t('button.confirm'),
            preConfirm: () => { 
              navigate('/login');
              sessionStorage.removeItem("inviteseq");
             }
          });
        }
      }).finally((fin)=>{
        setConfirmLoad(false);
      })
  }

  const handleStep2AddIn = () => { //已有公司帳號存在 加入 帶入公司名稱,地址 等API F0010102 完成後串入
    handleActiveIndex(2);
  }

  const handleActiveIndex = (step) => {
    switch (step) {
      case 0:
        setActiveIndex(step);
        reset();
        setAgreeMarketing(false);
        break;
      case 1:
        setActiveIndex(step);
        break
      case 2://最後一步確認資料
        setActiveIndex(step);
        break;
    }
  }

  const transType = (type)=>{
    let audience = '';
    switch(type){
      case 'A':
      case 'green':  
        audience = "EsgCustomer"
        break;
      case 'B':
      case 'blue':
        audience = 'EsgConsultant' 
        break;     
    }
    return audience
  }

  const handleRegisterAcct = (data) => {
    checkLoading(loading);
    let reqBody = {
      userAcct: data.userAcct,
      userPcode: data.userPcode,
      userPcodeSecond: data.userPcodeSecond,
      audience: transType(sessionStorage?.getItem("loadTheme"))  //身分別
    }
    registerAcct(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleActiveIndex(1);
          handleSuccessMessage(dispatch, t('message.account_check') + ' ' + t('message.success'));
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      })

  }

  const onSubmit = (data) => {
    if (activeIndex === 0) {
      handleRegisterAcct(data);
    }
    if (activeIndex === 1) {
      // alert("onSubmit",JSON.stringify(data))
        handleInviteCode();
    }else if (activeIndex === 2) { //註冊主子帳戶
      setConfirmLoad(true);
      // alert("onSubmit step3",JSON.stringify(data))

      let reqBody = {
        inviteSeq:sessionStorage?.getItem("inviteseq"),
        taxIdNum: data.taxIdNum,
        companyName: data.companyName,
        address: data.companyAddress,
        leader: data.companyLeader,
        email: data.companyEmail,
        industryCode:data.industryCode,
        userName: data.userName,
        // userPhone: data.userPhone,
        userEmail: data.userEmail,
        userAcct: data.userAcct,
        userPcode: data.userPcode,
        audience:transType(inviteObj?.type),
        issuer:issuer===undefined?"JDBC":issuer,
        locale:data.locale, //use language add 2025/04/22
        country:data.country,
        agreeMarketing: agreeMarketing ? 'Y' : 'N'
        
        // companySeq:inviteObj?.companySeq,
        // inviteCode:data.inviteCode,
        // inviteEndDate:data.inviteEndDate,
        // isSuspend:'N',
      }
      if(issuer==='GOOGLE'){ //Google 登入 以下欄位不需帶入
        reqBody.idToken = sessionStorage?.getItem("id_token");
        // reqBody.userName = null; //userName 由使用者自己輸入
        reqBody.userEmail = null;
        reqBody.userAcct = null;
        reqBody.userPcode = null;
      }

      reqBody.audience = transType(inviteObj?.type);
      handleMainSubAcct(reqBody);
    }

  }



  return (
    <LoginCommonOutline mainBgPos="main-right" pageTitle={`${t("register_sys")} ${t('invitationCode')}`} isMember={true} isInvite={true}>
      <div style={{display:'none'}}>
        <CompanyRoleSelector disabled={activeIndex===1 || activeIndex === 2 } onRoleChange={onRoleChange} type={sessionStorage?.getItem("loadTheme")} />
      </div>
      <Steps model={["", "", ""]} activeIndex={activeIndex} readOnly={true} className="mb-3 mt-4 register-steps"/>

      <form className='grid' ref={formRef} onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
        {/* step1 */}
        {
          activeIndex === 0 && (
            <>
              <div className='col-12'>
                <FormInput
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="userAcct"
                  labelText={t("account")}
                  type="text"
                  placeholder={t("account")}
                  rules={setValidForm("userAcct")}
                  enterClick={inputCheckKeyDown}
                />
              </div>
              <div className='col-12'>
                <FormInput
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="userPcode"
                  labelText={t('password')}
                  type="password"
                  placeholder={t('password')}
                  rules={setValidForm("userPcode")}
                  enterClick={inputCheckKeyDown}
                />
              </div>
              <div className="col-12">
                <FormInput
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="userPcodeSecond"
                  labelText={t('cfm_password')}
                  type="password"
                  placeholder={t('cfm_password')}
                  rules={doubleCheckPcodeSecond()}
                  enterClick={checkKeyDown}
                />
              </div>
              <div className='col-12 gap-2 flex-all-center'>
              <Button type="button" className="p-button-icon-only" icon='pi pi-google' onClick={(e) => { 
                e.preventDefault(); 
                handleLoginConfirm("GOOGLE",transType(inviteObj?.type));
              }} size="small" rounded outlined />
                <Button disabled={!isValid} type="submit" className='w-100' label={t("button.next_step")} />
              </div>

            </>
          )
        }
        {/* step2 驗證碼 */}
        {
          activeIndex === 1 && (
            <>
            {
              sessionStorage?.getItem("id_token")!==null && (
                <div className="col-12">
                  <label className="form-label">{t('account')}</label>
                  <span>{JSON.parse(sessionStorage?.getItem("decode_token"))?.['email']}</span>
                </div>
              )
            }
              <div className='col-12'>
             
                <FormInput
                  disabled={isExistCompany}
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="inviteCode"
                  labelText={t("inviteCode")}
                  type="text"
                  placeholder={t("inviteCode")}
                  enterClick={inputCheckKeyDown}
                  rules={registerOptions.inviteCode}
                />
              </div>
              <div className="col-12 gap-2 flex-all-center">
                    <Button
                      type="submit"
                      size='small'
                      className='w-100'
                      label={t("button.next_step")}
                    />
                
              </div>
            </>
          )
        }
        {/* step3 填寫公司資料 */}
        {
          activeIndex === 2 && (
            <>
            {
              interiorFlag ==='N' ?( 
              <RegisterStep3
                control={control}
                isExistCompany={isExistCompany}
                register={register}
                errors={errors}
                inputCheckKeyDown={inputCheckKeyDown}
                setValidForm={setValidForm}
                setValue={setValue}
              />)
              :
              (<RegInviteSubAcctStep3
                inviteObj={inviteObj}
                register={register}
                errors={errors}
                inputCheckKeyDown={inputCheckKeyDown}
                setValidForm={setValidForm}
              />)
            }
             
              {/* 共同行銷同意區域 */}
              <div className="col-12">
                <Tooltip target=".marketing-info-icon-invite" position="top" style={{ maxWidth: '320px' }} />
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                  <div
                    style={{
                      width: '16px',
                      height: '16px',
                      border: '1px solid #ccc',
                      borderRadius: '2px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: agreeMarketing ? '#4CAF50' : 'transparent',
                      cursor: 'pointer'
                    }}
                    onClick={() => setAgreeMarketing(!agreeMarketing)}
                  >
                    {agreeMarketing && (
                      <span style={{color: 'white', fontSize: '12px', fontWeight: 'bold'}}>✓</span>
                    )}
                  </div>
                  <span
                    style={{fontSize: '14px', cursor: 'pointer'}}
                    onClick={() => setAgreeMarketing(!agreeMarketing)}
                  >
                    {t('agree_marketing')}
                  </span>
                  <i
                    className="pi pi-info-circle marketing-info-icon-invite"
                    data-pr-tooltip={t('agree_marketing_detail')}
                    style={{fontSize: '14px', cursor: 'pointer', color: '#6c757d'}}
                  />
                </div>
              </div>

              <div className="col-12 gap-2 flex-all-center">
                <Button size='small'
                type="submit"
                 disabled={confirmLoad || !isValid} loading={confirmLoad}
                  className='w-100'
                  label={t("button.send")}
                  outlined
                />
              </div>
            </>



          )
        }

        <div className='field'>
          <a onClick={() => { navigate('/login');handleSessionClear(true);}} className="mobile-link">{t('click_log_in')}</a>
        </div>
      </form>
    </LoginCommonOutline>
  )
}
export default RegisterInvite;
